/* Toy Glory 2026 theme behaviour. No dependencies. */
(() => {
  const TG = window.TG || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  function money(cents) {
    const fmt = TG.moneyFormat || "£{{amount}}";
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === "amount_no_decimals" ? Math.round(n).toString() :
      k === "amount_with_comma_separator" ? n.toFixed(2).replace(".", ",") : two);
  }

  let toastTimer;
  function say(msg) {
    const t = $("#toast"); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => (t.hidden = true), 2400);
  }

  // Date windows (YYYY-MM-DD, end inclusive), checked in the visitor's browser
  function inWindow(el, now = new Date()) {
    const s = el.dataset.start, e = el.dataset.end;
    if (s && now < new Date(s + "T00:00:00")) return false;
    if (e && now > new Date(e + "T23:59:59")) return false;
    return true;
  }

  /* ---------- Announcement bar: a live campaign replaces the normal messages ---------- */
  function initAnnounce() {
    const bar = $("[data-announce]"); if (!bar) return;
    const camps = $$(".camp-msg", bar).filter(el => inWindow(el));
    if (camps.length) {
      $$(".msg", bar).forEach(el => (el.hidden = true));
      const c = camps[0]; c.hidden = false;
      bar.classList.add("camp");
      bar.style.setProperty("--camp", c.style.getPropertyValue("--camp"));
      bar.style.setProperty("--camp-ink", c.style.getPropertyValue("--camp-ink"));
    }
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    const hero = $("[data-hero]"); if (!hero) return;
    let slides = $$(".slide", hero), dots = $$(".dot", hero);
    // Drop dated slides that aren't live today (keep at least one)
    slides.forEach((s, i) => {
      if (!inWindow(s) && slides.length > 1) { s.remove(); dots[i] && dots[i].remove(); }
    });
    slides = $$(".slide", hero); dots = $$(".dot", hero);
    if (!slides.length) return;
    slides.forEach((s, i) => s.classList.toggle("on", i === 0));
    dots.forEach((d, i) => { d.classList.toggle("on", i === 0); d.setAttribute("aria-selected", i === 0); });
    if (slides.length < 2) { const ui = $(".slide-ui", hero); if (ui) ui.hidden = true; return; }
    const dur = +hero.dataset.duration || 6000;
    hero.style.setProperty("--dur", dur + "ms");
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let cur = 0, timer;
    const dotsWrap = $(".dots", hero);
    function go(n) {
      cur = (n + slides.length) % slides.length;
      slides.forEach((el, i) => el.classList.toggle("on", i === cur));
      dots.forEach((el, i) => { el.classList.remove("on"); el.setAttribute("aria-selected", i === cur); });
      void dotsWrap.offsetWidth;
      dots[cur].classList.add("on");
      schedule();
    }
    function schedule() { clearTimeout(timer); if (!reduce && !hero.matches(":hover")) timer = setTimeout(() => go(cur + 1), dur); }
    $("[data-prev]", hero)?.addEventListener("click", () => go(cur - 1));
    $("[data-next]", hero)?.addEventListener("click", () => go(cur + 1));
    dots.forEach((d, i) => d.addEventListener("click", () => go(i)));
    hero.addEventListener("mouseleave", schedule);
    hero.addEventListener("mouseenter", () => clearTimeout(timer));
    schedule();
  }

  /* ---------- Menu drawer, filters drawer ---------- */
  function initDrawers() {
    const drawer = $("#drawer");
    const openBtn = $("[data-open-menu]");
    if (drawer && openBtn) {
      openBtn.addEventListener("click", () => { drawer.hidden = false; openBtn.setAttribute("aria-expanded", "true"); document.body.classList.add("locked"); });
      $$("[data-close-menu]", drawer).forEach(b => b.addEventListener("click", () => { drawer.hidden = true; openBtn.setAttribute("aria-expanded", "false"); document.body.classList.remove("locked"); }));
    }
    const filters = $("#filters");
    if (filters) {
      $$("[data-open-filters]").forEach(b => b.addEventListener("click", () => filters.classList.add("open")));
      $$("[data-close-filters]").forEach(b => b.addEventListener("click", () => filters.classList.remove("open")));
    }
    document.addEventListener("keydown", e => {
      if (e.key !== "Escape") return;
      if (drawer && !drawer.hidden) drawer.hidden = true;
      filters?.classList.remove("open");
      closeBag();
      const su = $("#signup"); if (su && !su.hidden) closeSignup();
    });
  }

  /* ---------- Bag (AJAX cart) ---------- */
  const bag = () => $("#bag");
  function openBag() { const b = bag(); if (!b) return; b.hidden = false; document.body.classList.add("locked"); refreshBag(); }
  function closeBag() { const b = bag(); if (!b || b.hidden) return; b.hidden = true; document.body.classList.remove("locked"); }

  async function getCart() { const r = await fetch(TG.routes.root + "cart.js", { headers: { Accept: "application/json" } }); return r.json(); }

  function setCount(n) {
    $$("[data-cart-count]").forEach(el => { el.textContent = n; el.hidden = n === 0; });
  }

  function renderBag(cart) {
    setCount(cart.item_count);
    const lines = $("[data-bag-lines]"), foot = $("[data-bag-foot]"), meter = $("[data-ship-meter]"), cnt = $("[data-bag-count]");
    if (!lines) return;
    if (cnt) cnt.textContent = cart.item_count ? `(${cart.item_count})` : "";
    const free = TG.freeShip || 0;
    if (meter) {
      if (free > 0 && cart.item_count) {
        const left = free - cart.total_price;
        meter.hidden = false;
        meter.innerHTML = (left > 0 ? `<span>Spend <b>${money(left)}</b> more for free delivery</span>` : `<span><b>You've got free delivery</b></span>`) +
          `<div class="bar"><i style="width:${Math.min(100, (cart.total_price / free) * 100)}%"></i></div>`;
      } else meter.hidden = true;
    }
    if (!cart.item_count) {
      lines.innerHTML = `<div class="bag-empty"><p>Your bag is empty.</p><a class="btn" href="${TG.routes.root}collections/all">Start shopping</a></div>`;
      foot.innerHTML = ""; foot.hidden = true; return;
    }
    foot.hidden = false;
    lines.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        <a href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image + (it.image.includes("?") ? "&" : "?") + "width=180")}" alt="" loading="lazy" width="76" height="76">` : ""}</a>
        <div>
          <a class="t" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? "" : `<div class="v">${esc(it.variant_title || "")}</div>`}
          <div class="ctl">
            <div class="mini-qty"><button type="button" aria-label="Decrease" data-line="${i + 1}" data-q="${it.quantity - 1}">−</button><span>${it.quantity}</span><button type="button" aria-label="Increase" data-line="${i + 1}" data-q="${it.quantity + 1}">+</button></div>
            <button class="remove" type="button" data-line="${i + 1}" data-q="0">Remove</button>
          </div>
        </div>
        <div class="p">${money(it.final_line_price)}</div>
      </div>`).join("");
    const disc = (cart.cart_level_discount_applications || []).map(d => `<div class="row disc"><span>${esc(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join("");
    foot.innerHTML = `${disc}<div class="row"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
      <small>Delivery and discount codes are added at checkout. Plain, discreet packaging.</small>
      <a class="btn" href="${TG.routes.root}checkout">Checkout securely</a>
      <a class="btn ghost" href="${TG.routes.cart}">View bag</a>`;
  }
  async function refreshBag() { try { renderBag(await getCart()); } catch (e) {} }

  async function changeLine(line, quantity) {
    const r = await fetch(TG.routes.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
    const cart = await r.json();
    if (!r.ok) { say(cart.description || "Couldn't update your bag"); return refreshBag(); }
    renderBag(cart);
  }

  async function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }
    try {
      const r = await fetch(TG.routes.cartAdd + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
      const res = await r.json();
      if (!r.ok) { say(res.description || res.message || "Couldn't add that to your bag"); return false; }
      openBag();
      return true;
    } catch (e) { say("Couldn't add that to your bag"); return false; }
    finally { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } }
  }

  function initBag() {
    $$("[data-open-bag]").forEach(a => a.addEventListener("click", e => { if (!bag()) return; e.preventDefault(); openBag(); }));
    $$("[data-close-bag]").forEach(b => b.addEventListener("click", closeBag));
    $("[data-bag-lines]")?.addEventListener("click", e => {
      const b = e.target.closest("[data-line]"); if (!b) return;
      changeLine(+b.dataset.line, Math.max(0, +b.dataset.q));
    });
    document.addEventListener("click", e => {
      const q = e.target.closest("[data-quick-add]"); if (!q) return;
      e.preventDefault(); addToCart([{ id: +q.dataset.quickAdd, quantity: 1 }], q);
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    const page = $("[data-product-page]"); if (!page) return;
    const form = $("[data-product-form]", page);
    const dataEl = $("[data-product-json]");
    const data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    const idInput = $("[data-variant-id]", page);
    const addBtn = $("[data-add]", page);
    const stickyBtn = $("[data-sticky-add]"), stickyPrice = $("[data-sticky-price]");
    const stage = $("[data-stage]", page);

    const setStage = src => {
      if (!src || !stage) return;
      let img = $("img", stage);
      if (!img) { img = document.createElement("img"); stage.innerHTML = ""; stage.appendChild(img); }
      img.removeAttribute("srcset"); img.src = src;
    };
    $$("[data-thumb]", page).forEach(t => t.addEventListener("click", () => {
      setStage(t.dataset.thumb);
      $$("[data-thumb]", page).forEach(x => x.setAttribute("aria-current", x === t));
    }));

    const opts = $$(".opt", page);
    function selected() { return opts.map(o => $('[aria-pressed="true"]', o)?.dataset.value); }
    function update() {
      const sel = selected();
      const v = data.variants.find(x => x.options.every((val, i) => val === sel[i]));
      opts.forEach((o, i) => {
        $("[data-option-label]", o).textContent = sel[i] || "";
        $$("button", o).forEach(b => {
          const test = sel.slice(); test[i] = b.dataset.value;
          const ok = data.variants.some(x => x.available && x.options.every((val, j) => val === test[j]));
          b.classList.toggle("na", !ok);
        });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = "Unavailable"; } return; }
      idInput.value = v.id;
      const priceEl = $("[data-price]", page);
      const save = v.compare > v.price ? Math.floor(((v.compare - v.price) / v.compare) * 100) : 0;
      priceEl.innerHTML = `<b>${money(v.price)}</b>${save ? `<s>${money(v.compare)}</s><span class="save">Save ${save}%</span>` : ""}<small>Includes VAT</small>`;
      const stock = $("[data-stock]", page);
      stock.classList.toggle("out", !v.available);
      stock.textContent = v.available ? "In stock, ready to ship" : "Sold out";
      [addBtn, stickyBtn].forEach(b => { if (!b) return; b.disabled = !v.available; b.textContent = v.available ? "Add to bag" : "Sold out"; });
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.media) setStage(v.media);
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
    }
    opts.forEach(o => o.addEventListener("click", e => {
      const b = e.target.closest("button[data-value]"); if (!b) return;
      $$("button", o).forEach(x => x.setAttribute("aria-pressed", x === b));
      update();
    }));
    if (opts.length) update();

    const qty = $("[data-qty-input]", page);
    $$("[data-qty]", page).forEach(b => b.addEventListener("click", () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.qty); }));

    form?.addEventListener("submit", e => {
      if (!bag()) return; // fall back to normal form post
      e.preventDefault();
      addToCart([{ id: +idInput.value, quantity: Math.max(1, +qty.value || 1) }], addBtn);
    });
    stickyBtn?.addEventListener("click", () => form?.requestSubmit ? form.requestSubmit() : form.submit());

    // Hide the sticky bar while the main button is on screen
    const sticky = $("[data-sticky-buy]");
    if (sticky && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle("away", en.isIntersecting)).observe(addBtn);
    }
  }

  /* ---------- Product recommendations ---------- */
  async function initRecs() {
    const el = $("[data-recs]"); if (!el || el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const inner = doc.querySelector("[data-recs]");
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (e) {}
  }

  /* ---------- Collection: auto-submit filters, load more ---------- */
  function initCollection() {
    const form = $("[data-facets]");
    if (form) {
      form.addEventListener("change", e => { if (e.target.matches("[data-autosubmit]")) submitFacets(form); });
      form.addEventListener("submit", e => { e.preventDefault(); submitFacets(form); });
    }
    // Search results: plain "load next page" appending
    document.addEventListener("click", async e => {
      const a = e.target.closest("[data-load-more]"); if (!a || $("[data-grid][data-step]")) return;
      e.preventDefault();
      a.textContent = "Loading…";
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(a.href)).text(), "text/html");
        const grid = $("[data-grid]"), next = doc.querySelector("[data-grid]");
        if (grid && next) grid.append(...next.children);
        const more = $("[data-more]"), nextMore = doc.querySelector("[data-more]");
        if (more && nextMore) more.replaceWith(nextMore); else more?.remove();
      } catch (err) { location.href = a.href; }
    });
    initReveal();
  }

  /* Collection grid: in stock first, sold out after; reveal a step at a time, then fetch the next batch */
  function initReveal() {
    const grid = $("[data-grid][data-step]"); if (!grid) return;
    const step = +grid.dataset.step || 24, more = $("[data-more]");
    let shown = step;
    const apply = () => {
      const cards = [...grid.children];
      cards.forEach((c, i) => (c.hidden = i >= shown));
      if (!more) return;
      const total = +more.dataset.total, vis = Math.min((+more.dataset.offset || 0) + Math.min(shown, cards.length), total);
      $("[data-shown]", more).textContent = vis;
      const bar = $("[data-bar]", more); if (bar) bar.style.width = (vis / total) * 100 + "%";
      const btn = $("[data-load-more]", more);
      if (btn) btn.hidden = cards.length <= shown && btn.hasAttribute("data-no-next");
    };
    more?.addEventListener("click", async e => {
      const btn = e.target.closest("[data-load-more]"); if (!btn) return;
      e.preventDefault();
      if (grid.children.length > shown) { shown += step; return apply(); }
      if (btn.hasAttribute("data-no-next")) return;
      btn.textContent = "Loading…";
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(btn.href)).text(), "text/html");
        const next = doc.querySelector("[data-grid]"), nb = doc.querySelector("[data-more] [data-load-more]");
        if (next) grid.append(...next.children);
        if (nb && !nb.hasAttribute("data-no-next")) btn.href = nb.href; else btn.setAttribute("data-no-next", "");
        shown += step;
      } catch (err) { location.href = btn.href; return; }
      btn.textContent = "Load more";
      apply();
    });
    apply();
  }
  function submitFacets(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (v !== "") params.append(k, v); });
    location.search = params.toString();
  }

  /* ---------- Age check ---------- */
  function initGate() {
    const gate = $("#gate"); if (!gate || !TG.ageGate) return;
    if (store.get("tg_age_ok") === "1" || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
    gate.hidden = false; document.body.classList.add("locked");
    $("[data-gate-yes]", gate)?.focus();
    $("[data-gate-yes]", gate)?.addEventListener("click", () => { store.set("tg_age_ok", "1"); gate.hidden = true; document.body.classList.remove("locked"); maybeSignup(); });
    $("[data-gate-no]", gate)?.addEventListener("click", () => { location.href = TG.ageGateExit; });
  }

  /* ---------- Sign-up popup ---------- */
  function openSignup(email) {
    const su = $("#signup"); if (!su) return false;
    su.hidden = false; document.body.classList.add("locked");
    const inp = $("#su-email"); if (inp && email) inp.value = email;
    (inp || $("[data-close-signup]", su))?.focus();
    return true;
  }
  function closeSignup() {
    const su = $("#signup"); if (!su) return;
    su.hidden = true; document.body.classList.remove("locked");
    store.set("tg_signup_seen", String(Date.now()));
  }
  function maybeSignup() {
    if (!TG.signup || !$("#signup")) return;
    if (TG.ageGate && store.get("tg_age_ok") !== "1") return; // wait for the age check
    const seen = +store.get("tg_signup_seen") || 0;
    if (store.get("tg_signed_up") === "1" || Date.now() - seen < 14 * 864e5) return;
    setTimeout(() => { if (!document.body.classList.contains("locked")) openSignup(); }, TG.signupDelay || 12000);
  }
  function initSignup() {
    const su = $("#signup"); if (!su) return;
    $$("[data-close-signup]", su).forEach(b => b.addEventListener("click", closeSignup));
    $$("[data-open-signup]").forEach(b => b.addEventListener("click", () => openSignup()));
    if ($("[data-signup-done]", su)) { store.set("tg_signed_up", "1"); openSignup(); }
    $$("[data-copy]", su).forEach(b => b.addEventListener("click", async () => {
      try { await navigator.clipboard.writeText(b.dataset.copy); b.textContent = "Copied"; } catch (e) { say("Code: " + b.dataset.copy); }
    }));
    // The homepage newsletter form hands over to the popup (which adds the 18+ confirmation)
    $$("[data-news-form]").forEach(f => f.addEventListener("submit", e => {
      const email = f.querySelector('input[type="email"]')?.value.trim();
      if (openSignup(email)) e.preventDefault();
    }));
    maybeSignup();
  }

  /* ---------- Predictive search ---------- */
  function initPredictive() {
    $$("[data-predictive]").forEach(form => {
      const input = $('input[type="search"]', form), box = $(".pred", form);
      if (!input || !box || !TG.routes.predictive) return;
      let t, last = "";
      input.addEventListener("input", () => {
        clearTimeout(t);
        const q = input.value.trim();
        if (q.length < 2) { box.hidden = true; return; }
        t = setTimeout(async () => {
          if (q === last) return; last = q;
          try {
            const url = `${TG.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`;
            const r = await (await fetch(url)).json();
            const res = r.resources.results;
            const prods = (res.products || []).map(p => `<a class="pred-row" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" width="44" height="44">` : "<span></span>"}<span><b>${esc(p.title)}</b><small>${esc(p.vendor || "")} · ${esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : "")}</small></span></a>`).join("");
            const cols = (res.collections || []).map(c => `<a class="pred-chip" href="${esc(c.url)}">${esc(c.title)}</a>`).join("");
            const arts = (res.articles || []).map(a => `<a class="pred-chip" href="${esc(a.url)}">Guide: ${esc(a.title)}</a>`).join("");
            box.innerHTML = (cols || arts ? `<div class="pred-chips">${cols}${arts}</div>` : "") + (prods || `<p class="note">No products found for “${esc(q)}”.</p>`) +
              `<button class="pred-all" type="submit">See all results for “${esc(q)}” →</button>`;
            box.hidden = false;
          } catch (e) { box.hidden = true; }
        }, 180);
      });
      document.addEventListener("click", e => { if (!form.contains(e.target)) box.hidden = true; });
      input.addEventListener("keydown", e => { if (e.key === "Escape") box.hidden = true; });
    });
  }

  /* ---------- Account page: recover password toggle ---------- */
  function initAccount() {
    const lv = $("[data-login-view]"), rv = $("[data-recover-view]"); if (!lv || !rv) return;
    const show = rec => { lv.hidden = rec; rv.hidden = !rec; };
    $("[data-show-recover]")?.addEventListener("click", e => { e.preventDefault(); show(true); });
    $("[data-show-login]")?.addEventListener("click", e => { e.preventDefault(); show(false); });
    if (location.hash === "#recover" || rv.querySelector(".ok")) show(true);
  }

  function init() {
    initAnnounce(); initHero(); initDrawers(); initBag(); initProduct(); initRecs();
    initCollection(); initGate(); initSignup(); initPredictive(); initAccount();
    document.addEventListener("shopify:section:load", () => { initHero(); initAnnounce(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
